<template>
  <div class="w-full">
    <ToastAlert :is-active="toastAlert" :type="typeMsg" :message="msg" @close="closeToast"/>
    
    <!-- Loader -->
    <div v-if="loader" class="flex items-center justify-center">
      <div class="text-center">
        <img
          src="@/assets/imgs/tuin_loader_v2.gif"
          alt="cargando..."
          class="w-[500px] mx-auto"
        />
      </div>
    </div>

    <!-- Formulario responsive -->
    <div v-show="!loader" class="w-full">
      <h2 class="text-xl font-medium text-black mb-6">Agregar nuevo prospecto</h2>
      <div class="mb-4">
				<button
					class="py-2.5 px-2.5 rounded-full"
					@click="closeForm"
				>
					<svg xmlns="http://www.w3.org/2000/svg" width="23" height="18" viewBox="0 0 23 18" fill="none">
						<path d="M9.93061 17.1115C9.63057 17.4115 9.22368 17.58 8.79941 17.58C8.37515 17.58 7.96826 17.4115 7.66821 17.1115L0.468214 9.9115C0.168261 9.61145 -0.000244141 9.20456 -0.000244141 8.7803C-0.000244141 8.35604 0.168261 7.94914 0.468214 7.6491L7.66821 0.449099C7.96998 0.157644 8.37414 -0.00362587 8.79366 1.90735e-05C9.21317 0.00366592 9.61447 0.171934 9.91112 0.468588C10.2078 0.765242 10.376 1.16654 10.3797 1.58606C10.3833 2.00557 10.2221 2.40973 9.93061 2.7115L5.59941 7.1803L20.7994 7.1803C21.2238 7.1803 21.6307 7.34887 21.9308 7.64893C22.2308 7.94899 22.3994 8.35595 22.3994 8.7803C22.3994 9.20464 22.2308 9.61161 21.9308 9.91167C21.6307 10.2117 21.2238 10.3803 20.7994 10.3803L5.59941 10.3803L9.93061 14.8491C10.2306 15.1491 10.3991 15.556 10.3991 15.9803C10.3991 16.4046 10.2306 16.8115 9.93061 17.1115Z" fill="black"/>
					</svg>
				</button>
			</div>
      <!-- Formulario responsive con orden diferente en mobile vs desktop -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <!-- Campo 1: Nombre (mobile: 1, desktop: col 1 row 1) -->
        <div class="order-1 md:order-1">
          <p class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">Nombre*</p>
          <input
            v-model="name"
            type="text"
            placeholder="Ingresa el nombre del contacto"
            class="bg-white h-11 border border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5"
            required
          />
        </div>

        <!-- Campo 2: Apellido Paterno (mobile: 2, desktop: col 2 row 1) -->
        <div class="order-2 md:order-2">
          <p class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">Apellido Paterno*</p>
          <input
            v-model="last_name"
            type="text"
            placeholder="Ingresa el apellido paterno"
            class="bg-white h-11 border border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5"
            required
          />
        </div>

        <!-- Campo 3: Apellido Materno (mobile: 3, desktop: col 1 row 2) -->
        <div class="order-3 md:order-3">
          <p class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">Apellido Materno*</p>
          <input
            v-model="second_last_name"
            type="text"
            placeholder="Ingresa el apellido materno"
            class="bg-white h-11 border border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5"
            required
          />
        </div>

        <!-- Campo 4: Email (mobile: 4, desktop: col 1 row 3) -->
        <div class="order-4 md:order-5">
          <p class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">Email*</p>
          <input
            v-model="email"
            type="email"
            placeholder="Ingresa el correo electrónico"
            class="bg-white h-11 border border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5"
            required
          />
        </div>

        <!-- Campo 5: Número de Celular (mobile: 5, desktop: col 2 row 2) -->
        <div class="order-5 md:order-4">
          <p class="block mb-2 text-sm font-medium text-custom_gray dark:text-white">Número de Celular*</p>
          
          <div class="flex gap-2">
            <div class="w-32">
              <div class="custom-select-container">
                <div class="selected-option" @click.stop="toggleDropdown">
                  <div v-if="selectedCountry" class="country-item">
                    <img 
                      v-if="getSelectedCountry && getSelectedCountry.flag" 
                      :src="getSelectedCountry.flag" 
                      :alt="`Bandera de ${getSelectedCountry.name}`" 
                      class="flag-img"
                    />
                    <span>{{ selectedCountry }}</span>
                  </div>
                  <div v-else class="placeholder">País</div>
                  <div class="arrow-down"></div>
                </div>

                <!-- Dropdown options -->
                <div class="dropdown-menu" v-if="isDropdownOpen">
                  <div 
                    v-for="country in filteredCountries" 
                    :key="country.dial_code"
                    class="country-option"
                    @click="selectCountry(country.dial_code)"
                  >
                    <img 
                      v-if="country.flag" 
                      :src="country.flag" 
                      :alt="`Bandera de ${country.name}`" 
                      class="flag-img"
                    />
                    <span>({{ country.dial_code }})</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="flex-1">
              <input 
                type="text" 
                v-model="phone" 
                id="phone-input" 
                class="bg-white h-11 border border-gray-300 text-custom_gray text-base rounded-lg focus:ring-tuin_base-0 focus:border-tuin_base-0 block w-full p-2.5"
                placeholder="Ingresa tu número celular" 
                maxlength="10"
                required 
                @input="onlyNumbers" 
              />
            </div>
          </div>
        </div>
      </div>
      
      <!-- Botones -->
      <div class="flex items-end justify-end my-6">
        <button 
          @click="save" 
          class="w-full font-medium sm:w-auto px-5 py-2.5 bg-tuin-100 text-white rounded-lg text-sm hover:bg-tuin_hover disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        > 
          Guardar 
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, defineEmits, onMounted } from "vue";
import ToastAlert from "@/commond/ToastAlert.vue";

import axios from "axios";

import { useStore } from "vuex";
const store = useStore();
let session = computed(() => store.getters.getUserSession);

const emit = defineEmits(["triggerUpdateLead"]);

let loader = ref(false);
let toastAlert = ref(false);
let typeMsg = ref("");
let msg = ref("");

let name = ref("");
let last_name = ref("");
let second_last_name = ref("");
let email = ref("");
let phone = ref("");

// Variables para el selector de país
let selectedCountry = ref("");
let isDropdownOpen = ref(false);
let countryCodes = ref([]);

// Computed para obtener el país seleccionado
const getSelectedCountry = computed(() => {
  return countryCodes.value.find(country => country.dial_code === selectedCountry.value);
});

const filteredCountries = computed(() => {
  return [...countryCodes.value].sort((a, b) => a.name.localeCompare(b.name));
});

// Funciones para el selector de país
const toggleDropdown = () => {
  isDropdownOpen.value = !isDropdownOpen.value;
};

const closeDropdown = () => {
  isDropdownOpen.value = false;
};

const selectCountry = (dialCode) => {
  selectedCountry.value = dialCode;
  closeDropdown();
};

// Función para validar solo números en el teléfono
const onlyNumbers = (event) => {
  const value = event.target.value;
  event.target.value = value.replace(/[^0-9]/g, '');
  phone.value = event.target.value;
};

// Función para cerrar el dropdown cuando se hace clic fuera
const handleClickOutside = (event) => {
  const container = document.querySelector('.custom-select-container');
  if (container && !container.contains(event.target)) {
    isDropdownOpen.value = false;
  }
};

// Cargar códigos de país desde la API
const loadCountryCodes = async () => {
  const token = session.value ? session.value.token_api : null;

  if (!token) {
    console.error("No se encontró token de sesión");
    return;
  }

  const url = `${process.env.VUE_APP_API_BASE_URL}/get-country-preferences`;
  const options = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token.trim()}`,
    },
  };

  try {
    const response = await axios.get(url, options);
    countryCodes.value = response.data;

    // Establecer México (+52) como predeterminado si está disponible
    if (countryCodes.value.length > 0 && !selectedCountry.value) {
      const mexicoCountry = countryCodes.value.find(c => c.dial_code === '+52');
      
      if (mexicoCountry) {
        selectedCountry.value = '+52';
      } else {
        selectedCountry.value = countryCodes.value[0].dial_code;
      }
    }
  } catch (err) {
    console.error("Error fetching country codes:", err);
    // Fallback a México si falla la carga
    countryCodes.value = [{ name: "México", dial_code: "+52", flag: "https://flagcdn.com/w20/mx.png" }];
    selectedCountry.value = "+52";
  }
};

onMounted(async () => {
  loader.value = true;
  await loadCountryCodes();
  loader.value = false;
  document.addEventListener('click', handleClickOutside);
});

async function save() {
  let form_post = {
    name: name.value,
    last_name: last_name.value,
    second_last_name: second_last_name.value,
    email: email.value,
    phone: phone.value,
    country_code: selectedCountry.value,
  };

  let validation = await validateForm();

  if (validation.status !== "ok") {
    showToast("danger", validation.message);
    return false;
  }
  loader.value = true;

  try {
    let options = {
      headers: {
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    let url_link = `${process.env.VUE_APP_API_BASE_URL}/broker/lead/${session.value.id}/add`;

    const response = await axios.post(url_link, form_post, options);

    if (response.status == 401) {
      loader.value = false;
      store.dispatch("clearUserSession");
    }

    if (response.status == 200) {
      loader.value = false;
      showToast("success", "Datos guardados correctamente");
      closeForm()
    }
  } catch (error) {
    loader.value = false;
    if (error.response && error.response.status == 422) {
      const resp = error.response.data;
      if (resp.errors) {
        for (const field in resp.errors) {
          console.log(field);
          resp.errors[field].forEach((message) => {
            showToast("danger", message);
            setTimeout(() => {
              closeToast();
            }, 3000);
          });
        }
      }
    }

    console.error("Error fetching data:", error);
  }
}

function closeForm(){
    emit("triggerUpdateLead");
}

async function validateForm() {
  if (name.value == "" || name.value == null) {
    return { status: "fail", message: "El campo nombre es requerido" };
  }
  if (last_name.value == "" || last_name.value == null) {
    return {
      status: "fail",
      message: "El campo apellido paterno es requerido",
    };
  }
  if (second_last_name.value == "" || second_last_name.value == null) {
    return {
      status: "fail",
      message: "El campo apellido materno es requerido",
    };
  }
  if (email.value == "" || email.value == null) {
    return { status: "fail", message: "El campo email es requerido" };
  }

  if (!validateEmail(email.value)) {
    return { status: "fail", message: "Debes ingresar un correo válido" };
  }

  if (phone.value == "" || phone.value == null) {
    return { status: "fail", message: "El campo teléfono es requerido" };
  }
  return { status: "ok", message: "" };
}

function validateEmail(email) {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
}

async function showToast(type, message) {
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;

  setTimeout(() => {
    closeToast();
  }, 3000);
}

async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}
</script>

<style scoped>
.custom-select-container {
  position: relative;
  width: 100%;
  user-select: none;
}

.selected-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: white;
  cursor: pointer;
}

.country-item, .country-option {
  display: flex;
  align-items: center;
  gap: 8px;
}

.placeholder {
  color: #666;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #666;
  margin-left: 8px;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 200px;
  overflow-y: auto;
  background-color: white;
  border: 1px solid #ccc;
  border-top: none;
  border-radius: 0 0 8px 8px;
  z-index: 100;
}

.country-option {
  padding: 8px 12px;
  cursor: pointer;
}

.country-option:hover {
  background-color: #f5f5f5;
}

.flag-img {
  width: 24px;
  height: auto;
  vertical-align: middle;
  border: 1px solid #ddd;
}
</style>
